class FinancingSerializer {
  static deSerialize(data) {
    const price = FinancingSerializer.findPrice(data) || null;
    const zeroDayExpiry = FinancingSerializer.findFinancingFor('zero', data);
    const thirtyDayExpiry = FinancingSerializer.findFinancingFor('thirty', data);
    const withInitialPayment = FinancingSerializer.findFinancingFor('initialPayment', data);
    return {
      price,
      zeroDayExpiry,
      thirtyDayExpiry,
      withInitialPayment,
    };
  }

  static findPrice(data) {
    const priceItem = data.find(item => (
      item.TipoCuota &&
      item.TipoCuota.TCuCantidad === 1 &&
      (item.TipoCuota.TCuVencimientoE === null || item.TipoCuota.TCuVencimientoE === undefined) &&
      (item.TipoCuota.TCuDistancia === null || item.TipoCuota.TCuDistancia === undefined) &&
      item.TipoCuota.TCuVencimientoC === 0
    ));
    return priceItem ? priceItem.PViPrecio : null;
  }

  static findFinancingFor(expiryType, data) {
    return data.filter((item) => {
      if (expiryType === 'zero') {
        return FinancingSerializer.isZeroDayExpiry(item);
      } else if (expiryType === 'thirty') {
        return FinancingSerializer.isThirtyDayExpiry(item);
      } else if (expiryType === 'initialPayment') {
        return FinancingSerializer.isWithInitialPayment(item);
      }
      return false;
    }).map((item) => {
      const amount = item.TipoCuota.TCuCantidad || null;
      const fullPrice = item.PViPrecio;
      if (!amount || !fullPrice) {
        return {
          amount: null,
          price: null,
        };
      }
      return {
        amount,
        price: Math.round(fullPrice / amount),
      };
    }).sort((item1, item2) => {
      if ((item1.amount || 0) < (item2.amount || 0)) {
        return -1;
      } else if ((item2.amount || 0) < (item1.amount || 0)) {
        return 1;
      }
      return 0;
    });
  }

  static isWithInitialPayment(item) {
    return item.TipoCuota &&
           item.TipoCuota.TCuVencimientoE !== null &&
           item.TipoCuota.TCuVencimientoC > 0 &&
           item.TipoCuota.TCuDistancia > 0;
  }

  static isZeroDayExpiry(item) {
    return item.TipoCuota &&
      (item.TipoCuota.TCuVencimientoE === null || item.TipoCuota.TCuVencimientoE === undefined) &&
      item.TipoCuota.TCuVencimientoC === 0 &&
      item.TipoCuota.TCuDistancia > 0;
  }

  static isThirtyDayExpiry(item) {
    return item.TipoCuota &&
           item.TipoCuota.TCuVencimientoC > 0 &&
           item.TipoCuota.TCuDistancia > 0 &&
           item.TipoCuota.TCuVencimientoE === null;
  }
}

export { FinancingSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/FinancingSerializer.js